import PropTypes from "prop-types";
import { toast } from "sonner";

import ConfirmDeleteDialog from "components/modals/ConfirmDeleteDialog";
import RegionService from "services/Regions";

const DeleteRegionModal = ({ id, open, onOpenChange, onSuccess }) => {
  const handleConfirm = async () => {
    try {
      await RegionService.deleteRegion(id);
      toast.success("Region deleted");
      onOpenChange(false);
      await onSuccess();
    } catch {
      toast.error("Failed to delete region");
    }
  };

  return (
    <ConfirmDeleteDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Delete region?"
      description="Are you sure you want to delete this Region?"
      onConfirm={handleConfirm}
    />
  );
};

DeleteRegionModal.propTypes = {
  id: PropTypes.number.isRequired,
  open: PropTypes.bool,
  onOpenChange: PropTypes.func,
  onSuccess: PropTypes.func.isRequired,
};

export default DeleteRegionModal;
